// extracted by mini-css-extract-plugin
export default {"p":"_662e827d31 _483a5f6ec4 fe39b93f6b","clr":"_3b62b70a3d","dls":"_4472b46565"};